<template>
  <v-alert
      class="text-center"
      :value="!!alertType"
      :type="alertType">
    {{ textAlert }}
  </v-alert>
</template>

<script>
  import { REQUEST_STATUSES, LOT_REQUEST_TYPES } from '@/constants/business'

  export default {
    props: {
      requestStatus: {
        type: String
      },
      requestType: {
        type: String
      },
      processComment: {
        type: String
      },
      organizationId: {
        type: String
      }
    },
    computed: {
      canSendContractConditionFailRequest () {
        return this.organizationId &&
          this.organizationId !== this.currentOrganizationId &&
          this.requestType === LOT_REQUEST_TYPES.CONTRACT_CONDITION_FAIL
      },
      alertType () {
        const status = this.requestStatus
        switch (status) {
        case REQUEST_STATUSES.INPROCESS:
          return this.canSendContractConditionFailRequest
            ? null
            : 'error'
        case REQUEST_STATUSES.APPROVED:
          if (this.requestType === LOT_REQUEST_TYPES.RECALL) {
            return 'error'
          }
          break
        case REQUEST_STATUSES.REJECTED:
          return 'error'
        default:
          return null
        }
        return null
      },
      textAlert () {
        const status = this.requestStatus
        switch (status) {
        case REQUEST_STATUSES.INPROCESS:
          return this.canSendContractConditionFailRequest
            ? null
            : this.$t('Последний запрос находится в обработке у администратора. Вы не можете отправить запрос до завершения обработки предыдущего.')
        case REQUEST_STATUSES.APPROVED:
          if (this.requestType === LOT_REQUEST_TYPES.RECALL) {
            return this.$t('Торговая процедура уже отозвана.')
          }
          return null
        case REQUEST_STATUSES.REJECTED:
          const comment = this.processComment
            ? this.processComment
            : this.$t('не указана.')
          return this.$t('Последний запрос был отклонен Организатором. Причина') + ': ' + comment
        default:
          return null
        }
      }
    }
  }
</script>
